// extracted by mini-css-extract-plugin
export default {"img":"Category_img__0w94O","card":"Category_card__6PW1S","text":"Category_text__VawcO"};